/**
 * AI Models Settings Page
 * User Story 1: Configure AI Model Preferences
 * Dedicated page for managing AI model selection
 */

import { useBusinessProfile } from '../hooks/useBusinessProfile';
import { SettingsSubmenuMemo } from '../components/settings/SettingsSubmenu';
import { AiModelSettings } from '../components/settings/AiModelSettings';

export const AiModelsSettingsPage = () => {
  const { profile, isLoading, hasProfile } = useBusinessProfile();

  const mainContent = (
    <div className="container mx-auto max-w-3xl py-8">
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-3xl font-bold">AI Model Preferences</h1>
          <p className="mt-2 text-muted-foreground">
            Choose which AI models to use for generating social media posts. You can select multiple models to compare different outputs.
          </p>
        </div>

        {/* Loading State */}
        {isLoading && (
          <div className="rounded-lg border p-8 text-center">
            <p className="text-muted-foreground">Loading...</p>
          </div>
        )}

        {/* No Profile Warning */}
        {!isLoading && !hasProfile && (
          <div className="rounded-lg border border-yellow-200 bg-yellow-50 p-6 dark:border-yellow-900 dark:bg-yellow-900/20">
            <h3 className="text-lg font-semibold text-yellow-800 dark:text-yellow-400">
              Business Profile Required
            </h3>
            <p className="mt-2 text-sm text-yellow-700 dark:text-yellow-500">
              You need to create a business profile before configuring AI model preferences.
              Please visit the Business Settings page to create your profile first.
            </p>
          </div>
        )}

        {/* AI Model Settings */}
        {!isLoading && hasProfile && profile && (
          <div className="rounded-lg border p-6">
            <AiModelSettings businessId={profile._id} />
          </div>
        )}
      </div>
    </div>
  );

  return {
    submenu: <SettingsSubmenuMemo />,
    mainContent,
  };
};
